import { CxEvent } from '@spartacus/core';

export class Ga4GgListingProductsViewEvent extends CxEvent {
  event?: string;
  gtm?: {
    item_list_name?: string;
    visitor_type?: string;
    currency?: string;
    items?: {
      item_id?: string;
      item_name?: string;
      price?: string;
      index?: number;
    }[];
  };
}
